if (!customElements.get('wlsn-anchor-pills')) {
    class WLSNAnchorPills extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                activeClass: 'active',
                stickyClass: 'sticky',
                pill: 'js-wlsn-anchor-pill',
                section: 'shopify-section',
            };
            this.elements = {
                pills: this.querySelectorAll(`.${this.classes.pill}`),
                section: this.closest(`.${this.classes.section}`),
                sentinel: null,
            }
           
        }

        connectedCallback() {
            this.init();
        }

        disconnectedCallback() {
            if (this.stickyObserver) {
                this.stickyObserver.disconnect();
            }
            if (this.sectionObserver) {
                this.sectionObserver.disconnect();
            }
            if (this.elements.sentinel) {
                this.elements.sentinel.remove();
            }
        }

        init() {
            if (!this.elements.section) return;
    
            this.initStickyObserver();
            this.initSectionObserver();
            this.checkInitialVisibleSection();
        }

        initStickyObserver() {
            this.elements.sentinel = document.createElement('div');
            this.elements.sentinel.style.cssText = 'position: absolute; height: 1px; width: 1px; opacity: 0;';
            this.elements.section.parentElement.insertBefore(this.elements.sentinel, this.elements.section);
    
            const options = {
                threshold: [0],
                rootMargin: "0px 0px 0px 0px"
            };
    
            this.stickyObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) {
                        if (!this.elements.section.classList.contains(this.classes.stickyClass)) {
                            this.elements.section.classList.add(this.classes.stickyClass);
                        }
                    } else {
                        if (this.elements.section.classList.contains(this.classes.stickyClass)) {
                            this.elements.section.classList.remove(this.classes.stickyClass);
                        }
                    }
                });
            }, options);
    
            this.stickyObserver.observe(this.elements.sentinel);
        }

        initSectionObserver() {
            if (!this.elements.pills.length) return;
    
            const options = {
                root: null,
                rootMargin: "-30% 0px -30% 0px",
                threshold: 0
            };
    
            this.sectionObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    const pill = this.querySelector(`.${this.classes.pill}[href="#${entry.target.id}"]`);
                    if (!pill) return;
    
                    if (entry.isIntersecting) {
                        this.elements.pills.forEach(p => p.classList.remove(this.classes.activeClass));
                        pill.classList.add(this.classes.activeClass);
                        this.scrollPillIntoView(pill);
                    }
                });
            }, options);
    
            this.elements.pills.forEach(pill => {
                const href = pill.getAttribute('href');
                if (!href?.startsWith('#')) return;
    
                const sectionId = href.substring(1);
                const section = document.getElementById(sectionId);
                if (section) {
                    this.sectionObserver.observe(section);
                }
            });
        }

        checkInitialVisibleSection() {
            if (!this.elements.pills.length) return;
    
            const sections = Array.from(this.elements.pills).map(pill => {
                const href = pill.getAttribute('href');
                if (!href?.startsWith('#')) return null;
                return document.getElementById(href.substring(1));
            }).filter(Boolean);
    
            const visibleSection = sections.find(section => {
                const rect = section.getBoundingClientRect();
                return rect.top < window.innerHeight && rect.bottom > 0;
            });
    
            this.elements.pills.forEach(pill => pill.classList.remove(this.classes.activeClass));
    
            if (visibleSection) {
                const pill = this.querySelector(`.${this.classes.pill}[href="#${visibleSection.id}"]`);
                if (pill) {
                    pill.classList.add(this.classes.activeClass);
                    this.scrollPillIntoView(pill);
                }
            } else {
                const firstPill = this.elements.pills[0];
                if (firstPill) {
                    firstPill.classList.add(this.classes.activeClass);
                    this.scrollPillIntoView(firstPill);
                }
            }
        }
    
        scrollPillIntoView(pill) {
            const pillsContainer = pill.parentElement;
            if (!pillsContainer) return;
    
            const containerWidth = pillsContainer.offsetWidth;
            const pillLeft = pill.offsetLeft;
            const pillWidth = pill.offsetWidth;
            
            const scrollPosition = pillLeft - (containerWidth / 2) + (pillWidth / 2);
            
            pillsContainer.scrollTo({
                left: scrollPosition,
                behavior: 'smooth'
            });
        }
       
    }

    customElements.define('wlsn-anchor-pills', WLSNAnchorPills);
}
